
import React from "react";
import { useTranslation } from "react-i18next";
import { SettingsTabs } from "@/components/settings/SettingsTabs";

const Settings = () => {
  const { t } = useTranslation("settings");
  const tCommon = (key: string) => t(key, { ns: "common" });

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 container py-8 pb-20">
        <div className="mb-8">
          <h1 className="text-3xl font-bold tracking-tight">{tCommon('settings')}</h1>
          <p className="text-muted-foreground">{t('description')}</p>
        </div>

        <SettingsTabs />
      </div>
    </div>
  );
};

export default Settings;
